import React from "react";
import { Button } from "antd";
import { FileExcelOutlined } from "@ant-design/icons";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import dayjs from "dayjs";
import { getPOAll } from '../../services/plaOperativo/headerPlanOperativoServices';

const ExportarExcelPoa = ({ dataSource }) => {
    const exportToExcel = async () => {
        if (!dataSource || dataSource.length === 0) {
            console.warn("No hay datos para exportar.");
            return;
        }

        // 1) Creo el workbook y la primera pestaña
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("Porcentajes de Avance POAs");
        const headers = [
            "Proyecto",
            "Grupo Territorial",
            "Fecha Actualización",
            "Meta",
            "Meta Ejecutada",
            "Avance Ejecutado (%)",
        ];
        worksheet.addRow(headers);
        worksheet.getRow(1).eachCell(cell => {
            cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
            cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FF0070C0" } };
            cell.alignment = { horizontal: "center", vertical: "middle", wrapText: true };
            cell.border = {
                top: { style: "thin", color: { argb: "FF000000" } },
                left: { style: "thin", color: { argb: "FF000000" } },
                bottom: { style: "thin", color: { argb: "FF000000" } },
                right: { style: "thin", color: { argb: "FF000000" } },
            };
        });
        dataSource.forEach(row => {
            const proyecto = `${row.codigopre} - ${row.implementador}`;
            const grupoTerr = row.grupoterritorial || "";
            const fechaAsig = row.fecha_actualizacion
                ? dayjs(row.fecha_actualizacion).format("DD-MM-YYYY")
                : "";
            const meta = parseFloat(row.total_meta) || 0;
            const metaEj = parseFloat(row.total_meta_ejecutada) || 0;
            const pctEj = meta > 0 ? metaEj / meta : 0;

            const newRow = worksheet.addRow([proyecto, grupoTerr, fechaAsig, meta, metaEj, pctEj]);
            newRow.getCell(1).alignment = { horizontal: "left", vertical: "middle", wrapText: true };
            [4, 5].forEach(col => {
                newRow.getCell(col).numFmt = "0";
                newRow.getCell(col).alignment = { horizontal: "center", vertical: "middle" };
            });
            newRow.getCell(6).value = { formula: `=${(pctEj * 100).toFixed(1)}/100` };
            newRow.getCell(6).numFmt = "0.0%";
            newRow.getCell(6).alignment = { horizontal: "center", vertical: "middle" };
            newRow.eachCell(cell => {
                cell.border = {
                    top: { style: "thin", color: { argb: "FF000000" } },
                    left: { style: "thin", color: { argb: "FF000000" } },
                    bottom: { style: "thin", color: { argb: "FF000000" } },
                    right: { style: "thin", color: { argb: "FF000000" } },
                };
            });
        });
        worksheet.columns = [
            { width: 40 }, { width: 30 }, { width: 18 },
            { width: 12 }, { width: 14 }, { width: 18 },
        ];

        // 2) Creo la segunda pestaña con detalle de todos los proyectos
        const allResp = await getPOAll();

        if (allResp.status === 200 && Array.isArray(allResp.data)) {
            const ws2 = workbook.addWorksheet("Detalle POAs");
            // encabezados según columnasModal:
            const detHeaders = [
                "Cod_Factor", "Factor", "Proyecto", "Actividad", "Tarea", "Indicador",
                "Meta", "Meta Ejecutada", "Avance (%)",
                "Tipo de Actividad", "Actor"
            ];
            ws2.addRow(detHeaders);
            ws2.getRow(1).eachCell(cell => {
                cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
                cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FF0070C0" } };
                cell.alignment = { horizontal: "center", vertical: "middle", wrapText: true };
                cell.border = {
                    top: { style: "thin" }, left: { style: "thin" },
                    bottom: { style: "thin" }, right: { style: "thin" }
                };
            });
            // itero proyectos y sus detalles
            allResp.data.forEach(({ proyecto, detalle }) => {
                const projLabel = `${proyecto.codigo_pre} - ${proyecto.implementador}`;
                detalle.forEach(item => {
                    const meta = parseFloat(item.indicador.meta) || 0;
                    const metaEj = parseFloat(item.indicador.meta_ejecutada) || 0;
                    const pct = meta > 0 ? (metaEj / meta) * 100 : 0;
                    const row = ws2.addRow([
                        item.fase.nombre_corto,
                        item.fase.nombre_largo,
                        projLabel,
                        item.actividad.codigo + " - " + item.actividad.descripcion,
                        item.tarea.codigo + " - " + item.tarea.descripcion,
                        item.indicador.texto,
                        meta, metaEj, pct / 100,
                        item.indicador.tipo_actividad,
                        item.indicador.actor
                    ]);
                    // formato porcentaje
                    row.getCell(9).numFmt = "0.0%";
                    // alineaciones y bordes
                    row.eachCell((cell, col) => {
                        cell.alignment = { horizontal: col === 1 || col === 2 ? "left" : "center", vertical: "middle", wrapText: true };
                        cell.border = { top: { style: "thin" }, left: { style: "thin" }, bottom: { style: "thin" }, right: { style: "thin" } };
                    });
                });
            });
            // anchos
            ws2.columns = [
                { width: 30 }, { width: 30 }, { width: 30 }, { width: 30 }, { width: 25 }, { width: 40 },
                { width: 10 }, { width: 15 }, { width: 12 },
                { width: 20 }, { width: 20 },
            ];
        }

        // 3) guardo
        const buf = await workbook.xlsx.writeBuffer();
        saveAs(new Blob([buf], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), "Porcentajes_de_Avance_POAs.xlsx");
    };

    return (
        <Button
            type="primary"
            icon={<FileExcelOutlined />}
            onClick={exportToExcel}
            style={{ backgroundColor: "#28a745", borderColor: "#218838", color: "white" }}
        >
            Exportar
        </Button>
    );
};

export default ExportarExcelPoa;
